import React from "react"
import ProductModel from "../sdk/ProductModel"
import _ from "lodash"

export default class ProductModelMags extends ProductModel {

  constructor(data = {}) {
    super( data )
    if ( !data.desc ) return
    this.invalid = false
    this.description = this.desc.short_des
    this.title       = this.desc.short_des // .split(",")[0]
    this.excerpt     = this.description // .split('. ')[0] + "."
    this.setCount( 1 )
    this.setCount( 0 )
    this.setDefaultQuantity( "ict" )

    let shop      = window.shop
    let blacklist = shop.config.blacklist
    let langCode  = shop.session && shop.session.value && shop.session.value.country
    langCode      = langCode && langCode.trim()
    this.regionBlocker( langCode, blacklist )
  }

  // BLOCK ARTICLE IF IT'S IN THE BLACKLIST
  regionBlocker(langCode, blacklist) {
    if( !blacklist || !langCode) return
    let applicableList = blacklist[langCode]

    // Don't exclude sales articles
    if( this.extras.articletype === "02"){
      return
    }
    if( _.includes(applicableList, this.extras.brand)) {
      this.invalid = true
    }
  }

  setDefaultQuantity = (id) => {
    let found = this.quantities.filter( qty => qty.map_desc_id === id )
    if ( found.length >= 1 ) {
      let qty         = found[ 0 ]
      this.unit_multi = qty.multi
      this.unit_id    = qty.map_desc_id
    }
  }

  // this enables Bulk Pricing in super()
  set count(value) {
    this.setCount( value )
    this.findBulkPrice()
  }

  get count() {
    return this._count
  }

  getNotice({ size } = {}) {
    let product = this

    if ( size === "small" ) {
      return getSmallNotice( product )
    }

    switch (true) {
      case( product.stock <= 0):
        return <span>
          <i className="icon-circle icon-fw yellow" title={translate( "availability.soon" )}/> {translate( "availability.soon" )}
        </span>
      case( product.stock > 0):
        return <span>
          <i className="icon-circle icon-fw green" title="verfügbar"/> {translate( "availability.available" )}
        </span>
    }

  }
}

const getSmallNotice = (product) => {
  switch (true) {
    case( product.stock <= 0):
      return <span>
          <i className="icon-circle icon-fw yellow" title={translate( "availability.soon" )}/>
        </span>
    case( product.stock > 0):
      return <span>
          <i className="icon-circle icon-fw green" title="verfügbar"/>
        </span>
  }
}



// WEBPACK FOOTER //
// ./src/shop/ProductModelMags.js